import { ProductData } from '../modules/api/types/ProductData';
import { Node } from './Node';

export class Product extends Node<ProductData> {
    public get cover(): string {
        return this._rawData.field_principal?.[0]?.url
            ?? this._rawData.field_imagenes?.[0]?.url
            ?? this._rawData.field_palma?.[0]?.url
            ?? this._rawData.field_dorso?.[0]?.url
            ?? this._rawData.field_uso_image?.[0]?.url
            ?? '';
    }

    public get shortDesc(): string {
        return this._rawData.field_descripcion_corta_extended[0]?.value ?? '';
    }

    public get type(): string {
        return this._rawData.field_tipo?.[0]?.name[0]?.value ?? '';
    }

    public get colors(): string[] {
        return this._rawData.field_colores.map((c) => c.field_color[0]?.value).filter((c) => !!c);
    }
}
